exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header[data-v-93122a52]{z-index:10}.fade-enter-active[data-v-93122a52],.fade-leave-active[data-v-93122a52]{transition-duration:.3s;transition-property:opacity;transition-timing-function:ease}.fade-enter[data-v-93122a52],.fade-leave-active[data-v-93122a52]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-93122a52","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 248
// module chunks = 0